import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default  {
  
  ...cloneDeep(baseDefaults)

}

